import { File, Gem } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Tools } from "../../components/icons/tools";
import { Chip } from "../../components/ui/chip/chip";
import { MTUSelector } from "../../containers/mtu-selector/mtu-selector";
import { useWorkOrder } from "../../queries/work-order/use-work-order";
import { useWorkOrderOperation } from "../../queries/work-order/use-work-order-operation";
import { SignalStatus } from "../signal-status/signal-status";

export function ApplicationHeader() {
  const { t } = useTranslation();
  const {
    workOrderOperation,
    isPending: isPendingWorkOrderOperation,
    noActiveOperation,
    error: workOrderOperationError,
    refetch: refetchWorkOrderOperation,
  } = useWorkOrderOperation();
  const {
    workOrder,
    isPending: isPendingWorkOrder,
    error: workOrderError,
    refetch: refetchWorkOrder,
  } = useWorkOrder();

  if (noActiveOperation) return <SignalStatus />;

  return (
    <div className="flex gap-1.5">
      <Chip
        title={t("header.workOrder")}
        value={workOrder?.NId ?? ""}
        icon={<File />}
        loading={isPendingWorkOrder}
        error={workOrderError}
        onRetry={refetchWorkOrder}
      />
      <MTUSelector />
      <Chip
        icon={<Gem />}
        title={t("header.finalMaterial")}
        value={
          workOrder
            ? `${workOrder?.FinalMaterial.Material.NId}.${workOrder?.FinalMaterial.Material.Revision}`
            : ""
        }
        loading={isPendingWorkOrder}
        error={workOrderError}
        onRetry={refetchWorkOrder}
      />
      <Chip
        icon={<Gem />}
        title={t("header.finalMaterialDescription")}
        value={workOrder?.FinalMaterial.Material.Description ?? ""}
        loading={isPendingWorkOrder}
        error={workOrderError}
        onRetry={refetchWorkOrder}
      />
      <Chip
        icon={<Tools />}
        title={t("header.operationDescription")}
        value={workOrderOperation?.Description ?? ""}
        loading={isPendingWorkOrderOperation}
        error={workOrderOperationError}
        onRetry={refetchWorkOrderOperation}
      />
      <SignalStatus />
    </div>
  );
}
